import SessionEvent from 'session/SessionEvent.js';
import Tone from 'tone';
import {TRACK_SOLO} from 'session/constants.js';

class TrackSoloEvent extends SessionEvent {
    constructor(track, solo) {
        super();
        this.track = track;
        this.solo = solo;
    }

    isSkippable() {
        return false;
    }

    executeEvent(sequencerEngine) {
        this.subSequence.tracks[this.track.trackNumber].solo(this.solo, true);
    }

    getType() {
        return TRACK_SOLO;
    }

    getJson() {
        return { ... super.getJson(),
            trackNumber: this.track.trackNumber,
            solo: this.solo
        };
    }

    fromJson(json, sequencerEngine) {
        super.fromJson(json);
        this.track = sequencerEngine.tracks[json.trackNumber];
        this.solo = json.solo;
        return this;
    }
}

export default TrackSoloEvent;
